import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Grid, Stack } from "capitalrx-components-2.0/lib/layout";
import { Italic, Paragraph, Subheading } from "capitalrx-components-2.0/lib/typography";
import { ThemedRadioGroup, ThemedSubmitButton } from "@/App/components";

export const AuthTypeForm: FC<{ readonly identityProvider: string }> = ({ identityProvider }) => {
  const { t: translate } = useTranslation();
  return (
    <Grid testId="create-account-selection-container">
      <Grid.Span columns={12}>
        <Subheading textAlign="center">{translate("REGISTER.authTypeForm.createAccountSubHeading")}</Subheading>
      </Grid.Span>
      <Grid.Span columns={12}>
        <ThemedRadioGroup.Field testId="create-account-method" name="createAccountMethod">
          <ThemedRadioGroup.Option value="native">{translate("REGISTER.authTypeForm.emailAndPasswordOption")}</ThemedRadioGroup.Option>
          <ThemedRadioGroup.Option value="sso">
            <Stack spacing="none">
              <Paragraph>
                {translate("REGISTER.authTypeForm.connectSingleSignOnAccount")}
              </Paragraph>
              {identityProvider && (
                <Italic testId="identity-provider-location">{translate("REGISTER.authTypeForm.thisWillTakeYouTo", { identityProvider: identityProvider })}</Italic>
              )}
            </Stack>
          </ThemedRadioGroup.Option>
        </ThemedRadioGroup.Field>
      </Grid.Span>

      <Grid.Span columns={12}>
        <ThemedSubmitButton testId="next" appearance="primary" icon="arrow-right" iconPosition="right">
          {translate("REGISTER.authTypeForm.nextButton")}
        </ThemedSubmitButton>
      </Grid.Span>
    </Grid>
  );
};
